import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ParcelaCobrancaVale } from '../domain/parcela-cobranca-vale.model';

export class ParcelaCobrancaValeSerializer extends DomainSerializer<ParcelaCobrancaVale> {}
